export type UserWorkspaceRole = (typeof userWorkspaceRoles)[number]

export const userWorkspaceRoles = ['owner', 'editor', 'viewer'] as const
